// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3Kqnk","detailsBorder":"styles_detailsBorder__1IWhv"};